<script lang="ts">
	import { useStoryblokBridge } from '@storyblok/js';
	import DesktopNav from './desktopNav.svelte';
	import MobileNav from './mobileNav.svelte';
	import { onMount } from 'svelte';

	let { data, children } = $props();

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {});
	});
</script>

<div class="mx-container-mobile lg:mx-container-desktop">
	<div class="min-h-screen w-full bg-white py-28 lg:py-36 xl:mx-auto xl:w-5/6">
		<h1
			class="mb-15 text-[48px] font-bold leading-[48px] tracking-[-.02em] text-brown-1 lg:mb-18 lg:text-[80px] lg:leading-[88px] lg:tracking-[-.01em]"
		>
			{data.story.content.headline}
		</h1>
		<div class="flex gap-x-5 max-lg:flex max-lg:flex-col">
			<div class="w-full lg:w-2/5">
				<DesktopNav pages={data.story.content.pages} />
				<MobileNav pages={data.story.content.pages} />
			</div>
			<div class="w-full lg:w-3/5">
				{@render children()}
			</div>
		</div>
	</div>
</div>
